import React, { useEffect, useState, useMemo, useCallback } from "react";
import "./Shop.scss";

// import MainHeader from "../reusables/main_header";
import Product from "../reusables/products";
import ImgJumbotron from "../reusables/image_jumbotron";
import supermarket from "../../assets/supermarket.jpeg";
import http from "../../services/http-commons.js";
import { useDebounce } from "../utils/useDebounce";

const Shop = () => {
  // const Image =
  //   "https://i.postimg.cc/xjmj0KM4/mark-konig-Tl8m-Daue-II-unsplash.jpg";

  // Constants
  const categories = [
    "All",
    "Groceries",
    "Female Fashion",
    "wigs",
    "Tea",
    "Dishwashers",
    "Fragrances",
    "Snacks",
    "Insecticides",
    "Beverages",
    "Oral Care",
    "Feminine Care",
    "Bath & Body Products",
    "Cereals",
    "Detergents & Cleaning Supplies",
    "Bath Accessories",
    "Cleansers",
    "Diapers",
  ];

  // States
  const [products, setProducts] = useState([]);
  const [skip, setSkip] = useState(0);
  const [limit] = useState(20);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState("");
  const [category, setCategory] = useState("");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  // const [showPromo, setShowPromo] = useState(false);

  // Debounced query for search
  const debouncedQuery = useDebounce(query, 1000);

  // Derived values
  const currentPage = Math.floor(skip / limit) + 1;
  const totalPages = Math.ceil(total / limit);

  // ======= This should be moved to a separate service file --- HELPER FILE =======
  const isSameDay = (dateString) => {
    if (!dateString) return false;

    const savedDate = new Date(dateString);
    const today = new Date();

    return (
      savedDate.getFullYear() === today.getFullYear() &&
      savedDate.getMonth() === today.getMonth() &&
      savedDate.getDate() === today.getDate()
    );
  };

  const fetchProducts = useCallback(
    async (newSkip = 0, customQuery = "", customCategory = "") => {
      setLoading(true);

      try {
        const params = new URLSearchParams({
          skip: newSkip,
          limit: limit,
        });

        if (customQuery) {
          params.append("q", customQuery);
        }

        if (customCategory) {
          params.append("category", customCategory);
        }

        const res = await http.PRODUCTHTTP.get(
          `/products?${params.toString()}`,
        );

        setProducts(res.data.items);
        setTotal(res.data.total);
        setSkip(newSkip);
      } catch (err) {
        console.error("ERROR fetching products", err);
      } finally {
        setLoading(false);
      }
    },
    [limit],
  );

  // Search handler
  const searchAllProducts = () => {
    fetchProducts(0, query, category);
  };

  // Pagination controls
  const goToPage = (pageNum) => {
    const newSkip = (pageNum - 1) * limit;

    fetchProducts(newSkip, debouncedQuery, category);
  };

  const nextPage = () => {
    if (currentPage < totalPages) goToPage(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) goToPage(currentPage - 1);
  };

  // Handle window resizing
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Load initial products
  useEffect(() => {
    fetchProducts(0, debouncedQuery, category);
  }, [debouncedQuery, category, fetchProducts]);

  // Promotional popup logic (example)
  useEffect(() => {
    const lastShownDate = localStorage.getItem("promoLastShown");

    // show modal only on page 1 AND if it has not been shown today
    if (currentPage === 1 && !isSameDay(lastShownDate)) {
      // setShowPromo(true);
      localStorage.setItem("promoLastShown", new Date().toISOString());
    }
  }, [currentPage]);

  // Responsive styles
  const responsiveStyles = useMemo(() => {
    if (windowWidth <= 375) {
      return {
        text1Style: { fontSize: "14px", marginBottom: "0" },
        text2Style: { fontSize: "8px", marginBottom: "22px" },
        btnStyle: { width: "150px" },
      };
    } else if (windowWidth > 768) {
      return {
        text1Style: { fontSize: "28px", marginBottom: "0" },
        text2Style: { fontSize: "14px", marginBottom: "22px" },
        btnStyle: { width: "300px" },
      };
    } else {
      return {
        text1Style: { fontSize: "28px", marginBottom: "0" },
        text2Style: { fontSize: "14px", marginBottom: "22px" },
        btnStyle: { width: "300px" },
      };
    }
  }, [windowWidth]);

  // ==================== HTML OUTPUT STARTS HERE ====================
  return (
    <div>
      {/* <div className="shop-main-header">
        <div className="container">
          <MainHeader
            header={"Save More ON Banke"}
            text={`Experience the ease of shopping for fresh groceries online with Banke, 
              where quality meets convenience. 
              From farm-fresh produce to pantry staples, 
              enjoy swift delivery and hassle-free pickups that fit seamlessly into your busy schedule. 
              Discover a new way to shop that brings freshness to your doorstep with every order.`}
            image={Image}
            imgAlt={"Groceries Promotional image"}
          />
        </div>
      </div> */}

      <div className="main-content">
        <div className="container container-content">
          {/* Search Box */}
          <div className="row">
            <div className="input-group inputHolder">
              <input
                type="text"
                className="form-control form-control-xl"
                placeholder="Search Product"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
              />
              <span
                className="btn btn-primary btn-md"
                type="button"
                onClick={searchAllProducts}
              >
                Search
              </span>
            </div>
          </div>

          <div className="category-filter-wrapper">
            <div className="category-filter">
              {categories.map((item) => {
                const selectedCategory = item === "All" ? "" : item;
                const isActive = category === selectedCategory;

                return (
                  <button
                    key={item}
                    type="button"
                    className={`category-filter-item ${
                      isActive ? "active" : ""
                    }`}
                    onClick={() => {
                      setCategory(selectedCategory);
                      setSkip(0);

                      fetchProducts(0, debouncedQuery, selectedCategory);
                    }}
                  >
                    {item}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Product List */}
          <div className="row">
            <h4>Products</h4>
            {loading ? (
              <div className="login-required-container">
                <div className="account-loader"></div>
                <p>Loading your products...</p>
              </div>
            ) : products.length > 0 ? (
              products.map((item, index) => (
                <div key={index} className="col-md-3">
                  <Product
                    image={item.images}
                    imageAlt={item.name}
                    storeName={item?.vendor?.business_name ?? "---"}
                    productName={item.name}
                    productAmount={item.amount}
                    starRating={item.ratings}
                    getProduct={item}
                  />
                </div>
              ))
            ) : (
              <p>No products found...</p>
            )}
          </div>

          {/* Pagination Controls */}
          {totalPages > 1 && (
            <div
              className="pagination-controls mt-4"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "8px",
                flexWrap: "wrap",
              }}
            >
              {/* Previous button */}
              <button
                className="btn btn-outline-primary"
                onClick={prevPage}
                disabled={currentPage === 1}
              >
                Prev
              </button>

              {/* Page buttons (truncated) */}
              {(() => {
                const pages = [];

                // Always show current, next, and last few relevant pages
                if (currentPage <= 2) {
                  pages.push(1, 2, "ellipsis", totalPages);
                } else if (currentPage >= totalPages - 1) {
                  pages.push(1, "ellipsis", totalPages - 1, totalPages);
                } else {
                  pages.push(
                    1,
                    "ellipsis",
                    currentPage,
                    currentPage + 1,
                    "ellipsis",
                    totalPages,
                  );
                }

                return pages.map((p, index) =>
                  p === "ellipsis" ? (
                    <span key={index} style={{ padding: "0 5px" }}>
                      ...
                    </span>
                  ) : (
                    <button
                      key={index}
                      className={`btn ${
                        currentPage === p
                          ? "btn-primary"
                          : "btn-outline-primary"
                      }`}
                      onClick={() => goToPage(p)}
                    >
                      {p}
                    </button>
                  ),
                );
              })()}

              {/* Next button */}
              <button
                className="btn btn-outline-primary"
                onClick={nextPage}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Bottom Jumbotron */}
      <div className="jumbotron-area">
        <div
          className="row"
          style={{
            width: "75%",
            marginLeft: "auto",
            marginRight: "auto",
            height: "45vh",
          }}
        >
          <ImgJumbotron
            text1Style={responsiveStyles.text1Style}
            text2Style={responsiveStyles.text2Style}
            text1={"Can’t Spot Your Fave Product?"}
            text2={
              "Hit us up with your specs, and we’ll add it to our incoming lineup!"
            }
            btnStyle={responsiveStyles.btnStyle}
            backgroundImage={supermarket}
            btnText={"SHOOT YOUR REQUEST"}
          />
        </div>
      </div>
    </div>
  );
};

export default Shop;
